import React from "react";
import ReactDOM from "react-dom/client";
import "animate.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "@fontsource/cairo";
import "./index.css";
import App from "./App";
// import { createStore, applyMiddleware } from 'redux';
import { Provider } from "react-redux";
// import thunk from 'redux-thunk'
// import rootReducer from './store/reducers/rootReducer.js'
import { BrowserRouter } from "react-router-dom";
import { store } from "./store/store.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
// let store = createStore(rootReducer, applyMiddleware(thunk));

root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
    {/* </React.StrictMode> */}
  </Provider>
);
